import { Action, createReducer, on } from '@ngrx/store';
import { IDistributionChart } from '../models/user-analytics.model';
import * as actions from '../actions';

export const getFundingStatusDistributionChartKey = 'getFundingStatusDistributionChart';
export interface FundingStatusDistributionChartState {
  loadFundingStatusDistributionChartResponse: IDistributionChart[];
  loadFundingStatusDistributionChartResponseFailure: any;
  loaded: boolean;
}

export const initialState: FundingStatusDistributionChartState = {
  loadFundingStatusDistributionChartResponse: undefined,
  loadFundingStatusDistributionChartResponseFailure: undefined,
  loaded: false
};

export const reducer = createReducer(
  initialState,
  on(actions.loadFundingStatusDistributionChart, (state, action) => ({
    ...state
  })),
  on(actions.loadFundingStatusDistributionChartSuccess, (state, action) => ({
    ...state,
    loadFundingStatusDistributionChartResponse: action.response,
    loaded: true
  })),
  on(actions.loadFundingStatusDistributionChartFailure, (state, action) => ({
    ...state,
    loadFundingStatusDistributionChartResponseFailure: action.error
  }))
);

export const getFundingStatusDistributionChart = (state: FundingStatusDistributionChartState) => {
  if (state && state.loadFundingStatusDistributionChartResponse)
    return JSON.parse(JSON.stringify(state.loadFundingStatusDistributionChartResponse));
  else return null;
};

export const getFundingStatusDistributionChartIsLoaded = (state: FundingStatusDistributionChartState) => {
  state.loaded;
};
